/// <reference path="skyward.base.time.js" />
/// <reference path="skyward.ui.clock.ts" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.workflow = skyward.workflow || {};
        skyward.workflow.visualization = skyward.workflow.visualization || {};

        var highlightPadding = 20;
        var highlightTextOffset =
        {
            x: -10,
            y: -5
        };
        var arrowSize = 7;
        var nodeSize = 120;
        var nodePadding = 3;
        var visualizationWorker;
        var workerReady = true;

        var cacheLineHeight = function ()
        {
            var cached;
            return function (elem)
            {
                if (cached === undefined)
                {
                    cached = parseInt(window.getComputedStyle(elem).lineHeight, 10);
                }
                return cached;
            };
        };
        var cachedTitleHeight = cacheLineHeight();
        var cachedLabelHeight = cacheLineHeight();

        var createSvgElement = function (tagName, props)
        {
            var elem = document.createElementNS("http://www.w3.org/2000/svg", tagName);
            if (props !== undefined)
            {
                var keys = Object.keys(props);
                // jQuery's .attr() method can't be used for this because it transforms everything to
                // lowercase, but SVG attributes are case-sensitive.
                for (var i = 0; i < keys.length; i++)
                {
                    elem.setAttribute(keys[i], props[keys[i]]);
                }
            }
            return $(elem);
        };

        var appendSvg = function (container, tagName, props)
        {
            return createSvgElement(tagName, props).appendTo(container);
        };

        var appendUse = function (container, href, props)
        {
            var use = appendSvg(container, "use", props);
            use[0].setAttribute("href", href);
            return use;
        };

        var setTranslation = function (elem, x, y)
        {
            return $(elem).attr("transform", "translate(" + x + "," + y + ")");
        };

        var setGradient = function (defs, id, statuses, attrs)
        {
            var gradient = appendSvg(defs, "linearGradient", attrs);
            gradient.attr("id", id);

            if (statuses.length === 1)
            {
                appendSvg(gradient, "stop",
                {
                    "class": "taskHighlightColor " + statuses[0]
                });
                return;
            }

            // fade between solid colors -- inset each solid region so that the transitions take up 10% total
            var transitionSize = 0.10;
            var halfTransition = transitionSize / 2 / (statuses.length - 1);
            statuses.forEach(function (status, idx)
            {
                // solid color start
                appendSvg(gradient, "stop",
                {
                    "offset": (idx / statuses.length + halfTransition) * 100 + "%",
                    "class": "taskHighlightColor " + status
                });

                // solid color end
                appendSvg(gradient, "stop",
                {
                    "offset": ((idx + 1) / statuses.length - halfTransition) * 100 + "%",
                    "class": "taskHighlightColor " + status
                });
            });
        };

        var drawHighlight = function (svgParts, elem, highlightElem, node, statuses, text, time)
        {
            var id = "node_" + node.id + "_highlight";
            var gradientId = id + "_gradient";
            var rectId = id + "_rect";
            setGradient(svgParts.defs, gradientId, statuses,
            {
                "gradientUnits": "objectBoundingBox"
            });
            highlightElem.attr("id", id);

            var highlightRect = createSvgElement("rect",
            {
                "id": rectId,
                "x": -highlightPadding,
                "y": -highlightPadding,
                "width": node.width + highlightPadding * 2,
                "height": node.height + highlightPadding * 2,
                "ry": 3,
                "rx": 3
            });

            var clipPath = appendSvg(svgParts.defs, "clipPath").attr("id", id + "_clip");
            appendUse(clipPath, "#" + rectId);

            var statusText = createSvgElement("text",
            {
                "class": "taskHighlightText",
                "x": highlightTextOffset.x,
                "y": highlightTextOffset.y,
                "clip-path": "url(#" + id + "_clip)",
            })
            .text(text);

            var timeText = createSvgElement("text",
            {
                "class": "taskHighlightText",
                "x": highlightTextOffset.x,
                "y": node.height + highlightPadding + highlightTextOffset.y,
                "clip-path": "url(#" + id + "_clip)"
            })
            .text(time);

            highlightElem.append(highlightRect);
            elem.append(statusText.add(timeText));
            appendUse(svgParts.highlightDisplay, "#" + id,
            {
                "fill": "url(#" + gradientId + ")"
            });
            appendUse(svgParts.highlightMask, "#" + id,
            {
                "fill": "black"
            });
        };

        var highlightNode = function (svgParts, elem, highlightElem, node)
        {
            if (node.statuses.length > 0)
            {
                var timeString = "";
                if (node.statusTime !== undefined)
                {
                    var showDate = false;
                    var now = skyward.time.now();

                    var statusTime = new Date(skyward.time.parseISODate(node.statusTime));

                    if (now.getDate() !== statusTime.getDate())
                    {
                        showDate = true;
                        timeString += (statusTime.getMonth() + 1) + "/" + statusTime.getDate();
                        if (now.getFullYear() !== statusTime.getFullYear())
                        {
                            timeString += "/" + statusTime.getFullYear();
                        }
                        timeString += " ";
                    }

                    timeString += skyward.clock.formatTime(statusTime, { useSeconds: true });

                    var lastStatus = node.statuses[node.statuses.length - 1];
                    var timePrefix;
                    if (lastStatus === "InProgress" || lastStatus === "Waiting")
                    {
                        timePrefix = "since";
                    }
                    else
                    {
                        timePrefix = showDate ? "on" : "at";
                    }
                    timeString = timePrefix + " " + timeString;
                }

                drawHighlight(svgParts, elem, highlightElem, node, node.statuses, node.statusMessage, timeString);
            }
        };

        var wrapText = function (elem, str, widthFn, lineHeight)
        {
            var childSpans = document.createDocumentFragment();
            var appendNewSpan = function (line, lastLine)
            {
                // TSpan coordinates correspond to the text baseline.*  Offsetting the first element by lineHeight lets us treat
                // y-coordinates uniformly as the top of the element.  Unfortunately, any extra line-spacing will also be added.
                // * "Alignment-baseline" and "dominant-baseline" can override this, but support for them is limited.
                return appendSvg(childSpans, "tspan", {
                    "x": 0,
                    "dy": (line - lastLine) * lineHeight
                })[0];
            };

            var spacesOrEndSearch = /\s+|$/g;
            elem.textContent = str;

            var getNextWordLength = function (spanStart)
            {
                var nextMatch = spacesOrEndSearch.exec(str);
                var spaces = nextMatch !== null ? nextMatch[0].length : 0;
                var wordEnd = spacesOrEndSearch.lastIndex - spaces;
                return elem.getSubStringLength(spanStart, wordEnd - spanStart);
            };
            var getFittingChars = function (maxWidth, spanStart)
            {
                spacesOrEndSearch.lastIndex = spanStart;
                var lastGoodChar = spanStart;
                while (lastGoodChar < str.length && getNextWordLength(spanStart) <= maxWidth)
                {
                    lastGoodChar = spacesOrEndSearch.lastIndex;
                }
                if (spanStart !== lastGoodChar)
                {
                    return lastGoodChar;
                }
                while ((lastGoodChar + 1) < str.length &&
                    elem.getSubStringLength(spanStart, lastGoodChar + 1 - spanStart) <= maxWidth)
                {
                    lastGoodChar += 1;
                }
                return lastGoodChar;
            };

            var spanStart = 0;
            var line = -1;
            var lastLine = -1;
            var success = true;
            while (spanStart < str.length)
            {
                line += 1;
                var maxWidth = widthFn(line);
                if (isNaN(maxWidth))
                {
                    success = false;
                    break;
                }
                var spanEnd = getFittingChars(maxWidth, spanStart);
                if (spanStart === spanEnd)
                {
                    continue;
                }

                var currentSpan = appendNewSpan(line, lastLine);
                currentSpan.textContent = str.slice(spanStart, spanEnd);
                spanStart = spanEnd;
                lastLine = line;
            }
            return {
                spans: childSpans,
                success: success
            };
        };

        var wrapTitleText = function (titleElem, node, nodeInfo)
        {
            var lineHeight = cachedTitleHeight(titleElem);

            var words = node.title.trim();
            if (words.length === 0)
            {
                return nodeInfo.minHeight(0) || 0;
            }
            titleElem.textContent = words;
            var neededWidth = titleElem.getSubStringLength(0, words.split(" ")[0].length);
            var minHeight = Math.max(nodeInfo.minHeight(neededWidth) || 0, nodePadding);
            var startY = Math.ceil(minHeight);
            setTranslation(titleElem, node.width / 2, startY);

            var lineWidth = function (line)
            {
                var y = startY + lineHeight * line;
                return y <= node.height ? Math.min(nodeInfo.width(y), nodeInfo.width(y + lineHeight)) : undefined;
            };

            var wrapResult = wrapText(titleElem, words, lineWidth, lineHeight);
            var height = startY + wrapResult.spans.childNodes.length * lineHeight;
            titleElem.textContent = "";
            titleElem.appendChild(wrapResult.spans);
            return height;
        };

        var wrapLabelText = function (labelElem, text, bounds, nodeInfo)
        {
            labelElem.textContent = text;
            var requiredWidth = labelElem.getComputedTextLength();
            var lineHeight = cachedLabelHeight(labelElem);

            var getCenteredLineWidths = function (y, lines)
            {
                var startY = y - (lines * lineHeight) / 2;
                var widths = [];
                for (var i = 0; i < lines; i++)
                {
                    widths[i] = Math.min(nodeInfo.width(i * lineHeight + startY), nodeInfo.width(i * lineHeight + startY + lineHeight));
                }
                return {
                    widths: widths,
                    startY: startY
                };
            };

            var words = text.trim();
            if (words.length === 0)
            {
                return true;
            }

            var maxLines = bounds.maxHeight / lineHeight;
            if (maxLines < 1)
            {
                return false;
            }
            var wrapResult;
            for (var i = 1; i < maxLines; i++)
            {
                var lineWidth = getCenteredLineWidths(bounds.centerY, i);

                var totalWidth = lineWidth.widths.reduce(function (accum, line) { return accum + (line || 0); }, 0);
                if (totalWidth >= requiredWidth)
                {
                    wrapResult = wrapText(labelElem, words, function (line) { return lineWidth.widths[line]; }, lineHeight);
                    if (wrapResult.success)
                    {
                        labelElem.textContent = "";
                        labelElem.appendChild(wrapResult.spans);
                        setTranslation(labelElem, bounds.centerX, lineWidth.startY);
                        return true;
                    }
                }
            }

            wrapResult = wrapText(labelElem, words, function (line) { return lineWidth.widths[line]; }, lineHeight);
            labelElem.textContent = "";
            var lastElem = $(wrapResult.spans).children().last();
            lastElem.text(lastElem.text().slice(0, -3) + "...");
            setTranslation(labelElem, bounds.centerX, lineWidth.startY);
            labelElem.appendChild(wrapResult.spans);
            return false;
        };

        var wrapLabels = function (labels, node, nodeInfo, startY)
        {
            // Try to center solitary labels, so long as they don't overlap the title
            if (node.labels.length === 1)
            {
                var bounds = {
                    maxHeight: (node.height / 2 - startY) * 2,
                    centerX: node.width / 2,
                    centerY: node.height / 2
                };
                if (wrapLabelText(labels[0], node.labels[0], bounds, nodeInfo))
                {
                    return;
                }
                $(labels[0]).empty();
            }
            // Evenly distribute the available space among all labels
            var labelHeight = (node.height - startY) / node.labels.length;
            node.labels.forEach(function (text, i)
            {
                var bounds = {
                    centerX: node.width / 2,
                    centerY: labelHeight * (i + 0.5) + startY,
                    maxHeight: labelHeight
                };
                wrapLabelText(labels[i], text, bounds, nodeInfo);
            });
        };

        var getNodeInfo = function (node)
        {
            var centerY = node.height / 2;
            var innerSize = centerY - nodePadding;

            if (node.type === "InteractiveTask" || node.type === "BackgroundTask")
            {
                return {
                    minHeight: function ()
                    {
                        return 0;
                    },
                    width: function (y)
                    {
                        return y < innerSize * 2 ? innerSize * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        return createSvgElement("rect",
                        {
                            "x": 0,
                            "y": 0,
                            "width": node.width,
                            "height": node.height,
                            "ry": 3,
                            "rx": 3,
                        });
                    }
                };
            }
            if (node.type === "Start" || node.type === "End")
            {
                return {
                    minHeight: function (width)
                    {
                        width = width / 2;
                        if (width < innerSize)
                        {
                            var yOffset = Math.sqrt(innerSize * innerSize - width * width);
                            return centerY - yOffset;
                        }
                    },
                    width: function (y)
                    {
                        var height = centerY - y;
                        return height <= innerSize ? Math.sqrt(innerSize * innerSize - height * height) * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        return createSvgElement("ellipse",
                        {
                            "rx": node.width / 2,
                            "ry": node.height / 2,
                            "cx": node.width / 2,
                            "cy": node.height / 2,
                        });
                    }
                };
            }
            if (node.type === "Condition")
            {
                return {
                    width: function (y)
                    {
                        var height = Math.abs(centerY - y);
                        return height < innerSize ? (innerSize - height) * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        var start = { x: 0, y: 0 };
                        var center = { x: node.width / 2, y: node.height / 2 };
                        var end = { x: node.width, y: node.height };
                        var points = [
                            [start.x, center.y],
                            [center.x, end.y],
                            [end.x, center.y],
                            [center.x, start.y]
                        ];
                        return createSvgElement("polygon",
                        {
                            "points": points.map(function (point) { return point.join(","); }).join(" "),
                        });
                    }
                };
            }
            else
            {
                throw new Error("unknown node type " + node.type);
            }
        };

        var renderNodes = function (svgParts, nodes)
        {
            nodes.forEach(function (node)
            {
                var elem = appendSvg(svgParts.nodes, "g", { "class": "taskNode" });
                var highlightElem = appendSvg(svgParts.highlightDefs, "g");

                var nodeInfo = getNodeInfo(node);

                var lowercaseType = node.type[0].toLowerCase() + node.type.slice(1);
                var textClass = lowercaseType + "Text";

                nodeInfo.createBackground().addClass(lowercaseType + "Background").appendTo(elem);
                var titleHeight = 0;

                if (node.title !== undefined)
                {
                    var titleElem = appendSvg(elem, "text",
                    {
                        "text-anchor": "middle",
                        "class": "taskTitle " + textClass
                    })[0];
                    titleHeight = wrapTitleText(titleElem, node, nodeInfo);
                }

                var labels = [];
                for (var i = 0; i < node.labels.length; i++)
                {
                    labels[i] = appendSvg(elem, "text", {
                        "text-anchor": "middle",
                        "class": textClass
                    })[0];
                }

                wrapLabels(labels, node, nodeInfo, titleHeight);

                highlightNode(svgParts, elem, highlightElem, node);
            });
        };

        var formatLinePath = function (points)
        {
            return points.reduce(function (accum, point, pos)
            {
                accum += pos === 0 ? "M " : "L ";
                accum += point.x + "," + point.y + " ";
                return accum;
            }, "");
        };

        var drawConnectionHighlight = function (svg, defs, edge)
        {
            var gradientId = "edge_" + edge.id + "_highlight_gradient";
            setGradient(defs, gradientId, edge.statuses, {
                "gradientUnits": "userSpaceOnUse", // required for horizontal highlight paths to display: http://stackoverflow.com/a/21639059
                "x1": edge.points[0].x,
                "y1": edge.points[0].y,
                "x2": edge.points[edge.points.length - 1].x,
                "y2": edge.points[edge.points.length - 1].y,
            });

            var pathDefinition = formatLinePath(edge.points);
            appendSvg(svg, "path",
            {
                "stroke": "url(#" + gradientId + ")",
                "d": pathDefinition,
                "mask": "url(#connectionMask)",
                "class": "taskConnectionHighlight"
            });
        };

        var drawConnection = function (edgeDefs, edgeDisplay, defs, edge)
        {
            var group = appendSvg(edgeDisplay, "g");

            if (edge.statuses.length > 0)
            {
                drawConnectionHighlight(group, defs, edge);
            }

            var points = edge.points.slice();
            var secondlast = points[points.length - 2];
            var last = points[points.length - 1];
            var angle = Math.atan2(last.y - secondlast.y, last.x - secondlast.x);
            last.x = last.x - arrowSize * Math.cos(angle);
            last.y = last.y - arrowSize * Math.sin(angle);

            var pathDefinition = formatLinePath(points);

            appendSvg(edgeDefs, "path",
            {
                "d": pathDefinition,
                "marker-end": "url(#arrowhead)",
                id: edge.id
            });
            return appendUse(group, "#" + edge.id);
        };

        // http://pomax.github.io/bezierinfo/#intersections
        var linesIntersect = function (line1, offset1, line2, offset2)
        {
            var x1 = line1[offset1].x, x2 = line1[offset1 + 1].x, x3 = line2[offset2].x, x4 = line2[offset2 + 1].x;
            var y1 = line1[offset1].y, y2 = line1[offset1 + 1].y, y3 = line2[offset2].y, y4 = line2[offset2 + 1].y;
            var d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
            if (d === 0)
            {
                return false;
            }
            var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4);
            var ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4);
            var x = nx / d;
            var y = ny / d;
            return x >= Math.min(x1, x2) && x >= Math.min(x3, x4) && x <= Math.max(x1, x2) && x <= Math.max(x3, x4) &&
                   y >= Math.min(y1, y2) && y >= Math.min(y3, y4) && y <= Math.max(y1, y2) && y <= Math.max(y3, y4);
        };
        
        var anySegmentsIntersect = function (line1, line2)
        {
            for (var belowLine = 0; belowLine < line1.length - 1; belowLine++)
            {
                for (var aboveLine = 0; aboveLine < line2.length - 1; aboveLine++)
                {
                    if (linesIntersect(line1, belowLine, line2, aboveLine))
                    {
                        return true;
                    }
                }
            }
            return false;
        };

        var addEdgeMask = function (edges, edgeIdx, line, defs)
        {
            var edge = edges[edgeIdx];
            var mask = [];
            for (var above = edgeIdx + 1; above < edges.length && edges[above].bounds.minX <= edge.bounds.maxX; above++)
            {
                var aboveEdge = edges[above];
                // Masks are surprisingly expensive, enough so that we don't want to render them unless absolutely necessary.
                if (edge.bounds.intersects(aboveEdge.bounds) && anySegmentsIntersect(edge.points, aboveEdge.points))
                {
                    mask.push(above);
                }
            }
            if (mask.length > 0)
            {
                var maskId = edge.id + "_overlapMask";
                var maskElem = appendSvg(defs, "mask", {
                    "id": maskId,
                    "maskUnits": "userSpaceOnUse",
                    "class": "connectionOverlap"
                });
                appendSvg(maskElem, "rect",
                {
                    "x": 0,
                    "y": 0,
                    "width": "100%",
                    "height": "100%",
                    "fill": "white",
                    "stroke": "none"
                });
                for (var i = 0; i < mask.length; i++)
                {
                    appendUse(maskElem, "#" + edges[mask[i]].id);
                }
                line.attr("mask", "url(#" + maskId + ")");
            }
        };

        var BoundingBox = function (points)
        {
            this.minX = points[0].x;
            this.maxX = points[0].x;
            this.minY = points[0].y;
            this.maxY = points[0].y;
            for (var i = 1; i < points.length; i++)
            {
                this.minX = Math.min(this.minX, points[i].x);
                this.maxX = Math.max(this.maxX, points[i].x);
                this.minY = Math.min(this.minY, points[i].y);
                this.maxY = Math.max(this.maxY, points[i].y);
            }
        };

        BoundingBox.prototype.intersects = function (other)
        {
            return this.maxX >= other.minX && this.minX <= other.maxX &&
                   this.maxY >= other.minY && this.minY <= other.maxY;
        };

        var drawConnections = function (edgeDefs, edgeDisplay, defs, edges)
        {
            edges.forEach(function (edge)
            {
                edge.bounds = new BoundingBox(edge.points);
            });
            edges.sort(function (a, b) { return a.bounds.minX - b.bounds.minX; });

            edges.forEach(function (edge, idx)
            {
                var lineUse = drawConnection(edgeDefs, edgeDisplay, defs, edge);
                addEdgeMask(edges, idx, lineUse, defs);
            });
        };

        var setupSvg = function (body)
        {
            var svg = createSvgElement("svg")
            .addClass("workflowVisualization svgNoHover")
            .appendTo(body);

            var defXml =
                "<defs xmlns='http://www.w3.org/2000/svg'>" +
                    "<marker id='arrowhead' " +
                        "class='taskConnectionArrow' " +
                        "orient='auto' " +
                        "stroke='none' " + // only needed for IE 11
                        "viewBox='-0.5 -0.5 1 1' " +
                        "markerWidth='" + arrowSize + "' markerHeight='" + arrowSize + "'>" +
                            "<path d='M -0.4,-0.32 L -0.2,0 -0.4,0.32 0.4,0' />" +
                    "</marker>" +
                    "<mask id='connectionMask' maskUnits='userSpaceOnUse'>" +
                        "<rect x='0' y='0' width='100%' height='100%' fill='white' />" +
                    "</mask>" +
                "</defs>";
            svg.append(new DOMParser().parseFromString(defXml, "text/xml").documentElement);

            return svg;
        };

        var renderGraph = function (body, workflowId, nodes, edges)
        {
            nodes.forEach(function (node)
            {
                node.width = nodeSize;
                node.height = nodeSize;
            });

            // set up display area
            var svg = setupSvg(body);
            skyward.workflow.visualization.area = svg;

            var defs = svg.children("defs");
            var nodeHighlightCanvas = appendSvg(defs, "g", { "id": "nodeHighlights" });
            var nodeHighlightDisplay = appendSvg(svg, "g", { "class": "taskHighlightDisplay" });
            var edgeCanvas = appendSvg(defs, "g");
            var edgeDisplay = appendSvg(svg, "g", { "class": "taskConnections" });
            var nodeCanvas = appendSvg(svg, "g");

            var sendToWorker = function ()
            {
                workerReady = false;
                visualizationWorker.postMessage(
                {
                    options:
                    {
                        intCoordinates: true,
                        "de.cau.cs.kieler.klay.layered.feedBackEdges": true,
                        "de.cau.cs.kieler.klay.layered.mergeEdges": false
                    },
                    graph:
                    {
                        id: workflowId,
                        properties:
                        {
                            spacing: 50,
                            edgeRouting: "POLYLINE"
                        },
                        children: nodes.map(function (node)
                        {
                            return {
                                "id": node.id,
                                "width": node.width,
                                "height": node.height
                            };
                        }),
                        edges: edges.map(function (edge)
                        {
                            return {
                                "id": edge.id,
                                "source": edge.from,
                                "target": edge.to
                            };
                        })
                    }
                });
            };

            if (visualizationWorker === undefined)
            {
                visualizationWorker = new Worker(skyward.global.virtualDir + "Scripts/klay.js");
            }
            visualizationWorker.onmessage = function (e)
            {
                workerReady = true;
                var result = e.data;
                if (result.stacktrace !== undefined)
                {
                    throw $.extend(new Error("Graph layout worker threw an error: " + result.message), { details: result });
                }
                if (result.id !== workflowId)
                {
                    sendToWorker();
                    return;
                }

                skyward.workflow.visualization.graph = result;
                svg.height(result.height);
                svg.width(result.width);

                result.children.forEach(function (graphNode, idx)
                {
                    var elem = $(nodeCanvas.children()[idx]);
                    var highlightElem = $(nodeHighlightCanvas.children()[idx]);
                    setTranslation(elem, graphNode.x, graphNode.y);
                    setTranslation(highlightElem, graphNode.x, graphNode.y);
                });
                result.edges.forEach(function (graphEdge, idx)
                {
                    edges[idx].points = [graphEdge.sourcePoint].concat(graphEdge.bendPoints || []).concat(graphEdge.targetPoint);
                });
                drawConnections(edgeCanvas, edgeDisplay, defs, edges);
                // force Chrome to redraw the <use> elements referencing highlights
                nodeHighlightCanvas.children("[id]").each(function ()
                {
                    this.setAttribute("color", this.getAttribute("color") || "");
                });
                body.removeClass('loading');
                svg.show();
            };
            if (workerReady)
            {
                sendToWorker();
            }

            var svgParts =
            {
                nodes: nodeCanvas,
                highlightDefs: nodeHighlightCanvas,
                highlightMask: defs.find("#connectionMask"),
                highlightDisplay: nodeHighlightDisplay,
                defs: defs
            };
            renderNodes(svgParts, nodes);
            svg.hide();
        };

        skyward.workflow.visualization.display = function (workflow, area)
        {
            skyward.workflow.visualization.workflowdata = workflow;
            skyward.workflow.visualization.redraw = function ()
            {
                area.children().remove();
                var workflow = skyward.workflow.visualization.workflowdata;
                renderGraph(area, workflow.id.toString(), workflow.nodes, workflow.edges);
            };
            skyward.workflow.visualization.redraw();
        };

        skyward.window.registerLoadDOMCallback(function (selector)
        {
            $(selector + " .workflowVisualizationContainer").each(function ()
            {
                var $this = $(this);
                var graph = $this.data("graph");
                skyward.workflow.visualization.display(graph, $this);
            });
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);
